export default {
    route: {
        'title': 'Information Release System',
        'home': 'Home',
        'terminal': 'Terminal',
        'program': 'Program',
        'h5program': 'Program',
        'my': 'My',
        'remote_control': 'Remote Control',
        'task_details': 'Task Details',
        'add_task': 'Add Task',
        'program_list': 'Program List',
        'terminal_info': 'Terminal Information',
        'add_resolution': 'Add Resolution',
        'add_program': 'Add Program',
        'material_management': 'Material Management',
        'materialRecycleBin': 'Material Recycle Bin',
        'create_program': 'Create Program',
        'login': 'Login',
        'reset_password': 'Reset Password',
        'change_password': 'Change Password',
        'preview': 'Preview'
    },
      recharge_center: {
      title: "Recharge Center",
      tab_recharge: "Recharge",
      tab_order: "Orders",
      tab_invoice_record: "Records",
      summary_total_devices: "Total Devices",
      summary_expired_devices: "Expired Devices",
      summary_expiring_30_days: "Expiring Within 30 Days",
      select_plan: "Select Recharge Plan",
      plan_name_years: "{years}-Year Plan",
      price_unit_per_device: "/device",
      plan_desc_valid_years: "Valid for {years} year(s)",
      select_device: "Select Device",
      device_selection_stats: "Optional: {total} devices, Selected: {selected} devices",
      search_device_name: "Search device name",
      all_devices: "All Devices",
      expired_devices: "Expired Devices",
      expiring_within_30_days: "Expiring Within 30 Days",
      select_all: "Select All",
      no_renewable_device: "No renewable devices",
      pending_invoice_amount: "Pending Invoice Amount",
      product: "Product",
      amount: "Amount",
      status: "Status",
      time: "Time",
      order_detail: "Order Details",
      request_invoice: "Request Invoice",
      no_order: "No orders",
      package_label: "Plan",
      unselected: "Not Selected",
      total_label: "Total",
      recharge: "Recharge",
      wechat_scan_pay: "WeChat Scan to Pay",
      qr_expired_tip: "QR code expired. Please close and create a new order.",
      order_no: "Order No.",
      remaining_time: "Remaining Time",
      copy_link: "Copy Link",
      paid: "Paid",
      detail_description: "Details",
      invoice_title_info: "Invoice Title Info",
      select_saved_invoice_title_optional: "Select a saved invoice title (optional)",
      invoice_title: "Invoice Title",
      enter_or_select_invoice_title: "Enter or select invoice title",
      title_type: "Title Type",
      invoice_type: "Invoice Type",
      tax_no: "Tax Number",
      enter_tax_no: "Enter taxpayer identification number",
      phone: "Phone",
      optional_placeholder: "Optional",
      email: "Email",
      enter_email: "Enter email",
      fill_invoice_title: "Please enter the invoice title",
      select_title_type: "Please select a title type",
      select_invoice_type: "Please select an invoice type",
      enterprise_tax_no_required: "Enterprise title requires tax number",
      fill_email: "Please enter email",
      invalid_email: "Invalid email format",
      personal: "Personal",
      enterprise: "Enterprise",
      ordinary_invoice: "Regular Invoice",
      vat_invoice: "VAT Special Invoice",
      loading_devices: "Loading devices...",
      get_plan_failed: "Failed to load plans",
      select_plan_and_device: "Please select a plan and devices",
      device_count: "Devices",
      confirm_create_payment_order: "Confirm creating the payment order?",
      confirm_recharge: "Confirm Recharge",
      submitting: "Submitting...",
      create_order_failed: "Failed to create order",
      payment_marked: "Payment marked",
      invoice_available: "Invoice Available",
      invoiced: "Invoiced",
      order_load_failed: "Failed to load orders",
      invoice_submitted: "Invoice request submitted",
      filter_by_username: "Filter by username",
      all: "All",
      pending_invoice: "Pending Invoice",
      voided: "Voided",
      invoiced_amount: "Invoiced Amount",
      current_count: "Current Count",
      billing_time: "Billing Time",
      view: "View",
      download: "Download",
      no_invoice_record: "No invoice records",
      no_viewable_file: "No viewable file",
      no_downloadable_file: "No downloadable file"
  
  },
    append_field: {
        'input_code': 'Enter the code',
        'code_error': 'Verification code error',
        'fill_code': 'Please fill in the verification code',
        "dOut": "3D Rotation Out",
        "dIn": "3D Rotation In",
        "dxiao": "3D Frame Effect",
        "selectImage": "Please select an image",
        "onlySelectOneImage": "Only one image can be selected",
        "imageFormatError": "Image format error",
        "cancel": "Cancel",
        "selectedNumber": "Selected",
        "confirm": "Confirm",
        "loadinga": "Loading...",
        "loadingb": "Loading",
        "uploading": "Uploading",
        "selectStartDates": "Select start date",
        "selectEndDates": "Select end date",
        "createTask": "Create Task",
        "selectPrograms": "Select Programs",
        "createPrograms": "Create Programs",
        "editTask": "Edit Task",
        "fillTaskName": "Please fill in the name",
        "selectTaskGroup": "Please select a task group",
        "selectProgram": "Please select a program",
        "selected": "Selected",
        "programs": "programs",
        "selectDevice": "Please select a device",
        "sendTaskSuccess": "Task sent successfully",
        "taskName": "Name",
        "playMode": "Playback Mode",
        "replaceMode": "Replace Mode",
        "appendMode": "Append Mode",
        'apotpatterns': 'Insert Mode',
        "dateRange": "Playback Date",
        "timeRange": "Playback Time",
        "taskPeriod": "Specific week days",
        "mon": "Mon",
        "tue": "Tue",
        "wed": "Wed",
        "thu": "Thu",
        "fri": "Fri",
        "sat": "Sat",
        "sun": "Sun",
        "back": "Back",
        "programList": "Program List",
        "deviceList": "Device List",
        "enterContent": "Please enter content",
        "taskGroup": "Task Group",
        "selectStartDate": "Please select a start date",
        "selectEndDate": "Please select an end date",
        "selectStartTime": "Please select a start time",
        "selectEndTime": "Please select an end time",
        "addTask": "Add Task",
        "topLeft": "Top Left",
        "topCenter": "Top Center",
        "topRight": "Top Right",
        "leftCenter": "Left-aligned Center",
        "center": "Center",
        "rightCenter": "Right-aligned Center",
        "bottomLeft": "Bottom Left",
        "bottomCenter": "Bottom Center",
        "bottomRight": "Bottom Right",
        "enterText": "Please enter text",
        "fontColor": "Font Color",
        "bgColor": "Background Color",
        "scrollDirection": "Scroll Direction",
        "scrollSpeed": "Scroll Speed",
        "fontSize": "Font Size",
        "alignment": "Alignment",
        "subtitle": "Subtitle",
        "enterURL": "Please enter a URL",
        "webPage": "Web",
        "enterMediaURL": "Please enter a media URL",
        "media": "Media",
        "selectVideo": "Please select a video",
        "unsupportedFormat": "Unsupported file format",
        "cancelAllSelections": "Please cancel all selected materials before uploading new files",
        "fileName": "File Name",
        "fileSize": "File Size",
        "uploadProgress": "Upload Progress",
        "cancelUpload": "Cancel Upload",
        "cancelAllUploads": "Cancel all uploads",
        "leftToRights": "Left to Right",
        "rightToLefts": "Right to Left",
        "bottomToTops": "Bottom to Top",
        "static": "Static",
        "slow": "Slow",
        "medium": "Medium",
        "fast": "Fast",
        "colorValue": "Color Value",
        "defaultEffect": "Default Effect",
        "rightToLeft": "Right to Left",
        "leftToRight": "Left to Right",
        "topToBottom": "Top to Bottom",
        "bottomToTop": "Bottom to Top",
        "accordionSqueeze": "Accordion Squeeze",
        "zoomInFade": "Zoom In Gradient",
        "zoomOutFade": "Zoom Out Gradient",
        "depthOfField": "DOF Gradient",
        "leftRightRotate": "Left-Right Rotation",
        "upDownRotate": "Up-Down Rotation",
        "counterclockwiseRotate": "Counterclockwise Rotation",
        "clockwiseRotate": "Clockwise Rotate",
        "upDownZoom": "Zoom Up/Down",
        "scaleFade": "Zoom Gradient",
        "zoomInDisappearing": "Zoom and Fade Out Animation",
        "transparentFade": "Transparency Gradient",
        "gradientScale": "Gradient Zoom",
        "deleteMaterial": "Delete material",
        "confirmDeleteMaterial": "Confirm delete this material?",
        "unreviewed": "Unreviewed",
        "normal2": "Normal",
        "violating": "Violating",
        "suspectedViolating": "Suspected Violating",
        "delete": "Delete",
        "selectMaterial": "Please select material",
        "deleteProgramGroup": "Delete program group",
        "confirmDeleteGroup": "Are you sure you want to delete this group?",
        "add": "Add",
        "toggle_effect": "Animation Effect",
        "toggle_time": "Toggle Time",
        "pub_toggle_time": "Picture Playback Time",
        "fullscreen": "Fullscreen",
        "normal": "Normal",
        "interactive": "Interactive",
        "main_screen": "Main Screen",
        "sub_screen": "Sub Screen",
        "dual_screen": "Dual screen display",
        "sync_task": "Sync Task",
        "normal_mode": "Normal Mode",
        "basic_info": "Basic Info",
        "program_info": "Program Info",
        "task_name": "Program Name",
        "task_type": "Task Type",
        "pub_task": "Normal Task",
        "hu_task": "Interactive Task",
        "no_data": "No Data",
        "no_msg": "No Information",
        "program_name": "Program Name",
        "program_resolution": "Program Resolution",
        "program_type": "Program Type",
        "screen_category": "Screen Category",
        "edit_program": "Edit Program",
        "edit": "Edit",
        "send": "Send",
        "create": "Create Group",
        "reload": "Reload",
        "name": "Name",
        "create_task_z": "Create task group",
        "ps_push_name": "Please enter group name",
        "device_list": "Device List",
        "delete_task_group": "Delete task group",
        "confirm_delete_group": "Are you sure you want to delete this group?",
        "delete_success": "Delete success",
        "name_cannot_be_empty": "Name cannot be empty",
        "character_length_limit": "Character length must be within 10 characters",
        "create_task_success": "Task created successfully",
        "create_task_failed": "Task creation failed",
        "confirm_delete_task": "Are you sure you want to delete the task?",
        "task_details": "Task Details",
        "download_success": "Download Successful",
        "waiting_download": "Waiting for download",
        "downloading": "Downloading",
        "confirm_delete": "Are you sure you want to delete?",
        "confirm_delete_all": "Are you sure you want to delete all?",
        "confirm_delete_selected": "Are you sure you want to delete selected?",
        "no_data_to_clear": "No data to clear!",
        "refresh": "Refresh",
        "clear_all": "Clear All",
        "clear_completed": "Clear Completed",
        "device_id": "Device ID",
        "task_size": "Task Size",
        "speed": "Speed",
        "download_progress": "Download Progress",
        "title": "Title",
        "volume": "Volume",
        "deleteP": "Delete Program",
        "con_P": "Are you sure you want to delete this program?",
        "clear": "Clear",
        "download_status": "Download Status",
        "height_width_cannot_be_empty": "Height/width cannot be empty",
        "add_success": "Add Success",
        "enter_number_between_300_to_8000": "Please enter a number between 300 and 8000",
        "width": "Width",
        "enter_width": "Please enter width",
        "height": "Height",
        "enter_height": "Please enter height",
        "confirm_leave_page": "Are you sure you want to leave this page?",
        "add_content_to_control": "Please add content to control",
        "add_control": "Please add control",
        "save_success": "Save Success",
        "save": "Save",
        "create_program": "Create Program",
        "guess": "Guess",
        "modify": "Modify",
        "text": "Text",
        "image": "Picture",
        "background_image": "Background Image",
        "background_music": "Background Music",
        "replace": "Replace",
        "use_this_template": "Use this template",
        "apply_template": "Apply Template",
        "enter_program_name": "Please enter program name",
        "program_group": "Program Group",
        "select_program_group": "Please select program group",
        "group_list": "Group List",
        "preview": "Preview",
        "my_apps": "My apps",
        "template_center": "Template Center",
        "home": "Home",
        "source_of_visit": "Source of visit",
        "online": "Online",
        "terminal_status": "Status",
        "memory_status": "Storage Capacity",
        "material_recycle_bin": "Material Recycle Bin",
        "material_recycle_bin_tips": "Deleted materials can be restored or permanently removed here.",
        "recycle_search_placeholder": "Search material name",
        "recycle_type_all": "All types",
        "recycle_type_doc": "Documents",
        "recycle_type_img": "Images",
        "recycle_type_audio": "Audio",
        "recycle_type_video": "Video",
        "recycle_type_unknown": "Other",
        "recycle_empty": "Recycle bin is empty",
        "recycle_restore_selected": "Restore selected",
        "recycle_clear_selected": "Delete selected",
        "recycle_restore_all": "Restore all",
        "recycle_clear_all": "Empty recycle bin",
        "recycle_select_first": "Please select items first",
        "recycle_restore_all_tip": "All materials in the recycle bin will be restored to the folder you selected below. Continue?",
        "recycle_clear_tip": "Permanently delete selected items? This cannot be undone.",
        "recycle_clear_all_tip": "Permanently delete all items in the recycle bin? This cannot be undone.",
        "recycle_done": "Done",
        "recycle_fail": "Operation failed",
        "recycle_load_fail": "Failed to load",
        "recycle_btn_delete": "Delete",
        "recycle_btn_restore": "Restore",
        "recycle_summary_total": "{n} items",
        "recycle_summary_size": "Total size {s}",
        "recycle_summary_checked": "{n} selected",
        "recycle_remain_auto_clear": "{n}d",
        "recycle_days_unit": "d",
        "recycle_switch_off_notice": "Note: After you turn off the recycle bin, deleted materials will be permanently removed.",
        "recycle_restore_target_folder": "Restore to folder",
        "recycle_folder_pick_title": "Choose restore folder",
        "recycle_folder_select_this": "Use this folder",
        "recycle_folder_tap_select": "Choose a folder",
        "recycle_folder_invalid": "Invalid folder",
        "recycle_folder_load_fail": "Failed to load folders",
        "recycle_folder_empty": "No folders",
        "recycle_folder_pick_first": "Please select a folder to restore to",
        "login": "Login",
        "sms_verification": "SMS Verification",
        "email_verification": "Email Verification",
        "log_in": "Login",
        "enter_username": "Please enter username",
        "username_cannot_be_empty": "Username cannot be empty",
        "password_cannot_be_empty": "Password cannot be empty",
        "incorrect_phone_format_for_verification_code": "The phone number format for the verification code is incorrect, please contact the administrator to modify it!",
        "incorrect_email_format_for_verification_code": "The email format for the verification code is incorrect, please contact the administrator to modify it!",
        "incorrect_phone_or_email_format_for_verification_code": "The email or phone format for the verification code is incorrect, please contact the administrator to modify it!",
        "reset_password": "Reset Password",
        "remember_password": "Remember Password",
        "register": "Register Account",
        "current_version_4.1.6": "V4.1.8",
        "notification_about_network_security": "Notification about network security",
        "got_it": "Got it",
        "please_authenticate_for_account_safety": "Authenticate for safety",
        "enter_account": "Please enter account",
        "enter_password": "Please enter password",
        "verification_code": "Code",
        "none": "None",
        "personal_center": "Personal Center",
        "remote_control": "Remote Control",
        "refresh_success": "Refresh success!",
        "logout": "Logout",
        "confirm_logout": "Are you sure you want to log out?",
        "user_status": "User Status",
        "customer_address": "Customer Address",
        "account_period": "Account Period",
        "device_control": "Device Control",
        "clear_cache": "Clear Cache",
        "exit": "Exit",
        "terminal": "Terminal",
        "program": "Program",
        "material": "Material",
        "my": "My",
        "display_type": "Display Type",
        "proportion": "Ratio",
        "resolution": "Resolution",
        "screen_orientation": "Screen Orientation",
        "landscape": "Landscape",
        "portrait": "Vertical",
        "add_resolution": "Add Resolution",
        "execute_formatting_when_focus_lost": "Execute formatting when focus lost",
        "select_resolution": "Please select resolution",
        "resolution_list": "Resolution List",
        "confirm_delete_program": "Are you sure you want to delete the program?",
        "confirm_delete_this_program": "Are you sure you want to delete this program?",
        "bound_tasks_exists_confirm_delete": "Bound tasks exist, are you sure you want to delete?",
        "prompt": "Prompt",
        "delete_failed": "Delete Failed",
        "modification_time": "Modification Time",
        "resolution_": "Resolution",
        "associated_tasks": "Associated Tasks",
        "bound_task": "Bound Task",
        "program_management": "Program management",
        "task": "Task",
        "progress": "Progress",
        "phone_number": "Phone",
        "enter_phone_number": "Enter phone number",
        "password": "Password",
        "confirm_password": "Confirm Password",
        "enter_password_again": "Please enter password again",
        "company_name": "Company Name",
        "enter_company_name": "Please enter your company information",
        "address": "Address",
        "enter_address": "Please enter contact address",
        "username_not_exist": "Username does not exist",
        "enter_new_password": "Please enter new password",
        "enter_new_password_again": "Please enter new password again",
        "terminal_management": "Terminal Management",
        "delete_group": "Delete Group",
        "pel_select_group": "Please select group",
        "enter_device_name": "Please enter device name",
        "delete_device": "Delete Device",
        "confirm_delete_device": "Are you sure you want to delete this device?",
        "terminal_information": "Terminal information",
        "qr_code_error": "QR code error",
        "device_not_supported": "Device not supported",
        "device_offline": "The selected device must be online to issue commands. Please reselect!",
        "more": "More",
        "device_access": "Device Access",
        "filter": "Filter",
        "all": "All",
        "offline": "Offline",
        "device_name": "Device Name",
        "device_number": "Device Number",
        "device_group": "Device Group",
        "call_device_please_wait": "Calling device, please wait...",
        "create_terminal_group": "Create device group",
        "enter_search_keyword": "Enter search keyword",
        "bind_device": "Bind Device",
        "select_device_group": "Please select device group",
        "authorized": "Authorized",
        "unauthorized": "Unauthorized",
        "adjust_volume": "Adjust  Volume",
        "reboot_device": "Reboot Device",
        "wake_up": "Wake Up",
        "sleep": "Hibernate",
        "shutdown": "Power Off",
        "clean_up_timing_on_off": "Clear Timer",
        "clean_up_disk": "Clear Disk",
        "clean_up_task": "Clean Task",
        "send_command": "Send Command",
        "confirm2": "Send -",
        "terminal_operation": "Terminal Operation",
        "bind_task": "Task Information",
        "remote_command": "Remote Command",
        "remote_monitor": "Remote Monitoring",
        "adding_one_will_override_the_previous": "Only one scheduled record is allowed",
        "screenshot_in_progress_please_wait": "Screenshot in progress, please wait",
        "schedule_on_off": "Timed Power-On/Off",
        "shutdown_time": "Shutdown Time",
        "startup_time": "Startup Time",
        "volume_setting": "Volume Setting",
        "edit_device_name": "Edit device name",
        "please_select_time": "Please select time",
        "device_not_online_please_retry": "Device not online, please retry",
        "sent_successfully": "Sent successfully",
        "version": "V4.1.8",
        "texta": "Text",
        "userName": "Username",
        "email": "Email",
        "device_memory": "Device Memory",
        "device": "Device",
        "device_mac": "Device MAC",
        "screen_count": "Screen Count",
        "device_location": "Device Location",
        "is_authorized": "Is Authorized",
        "remark": "Remark",
        "device_ip": "Device IP",
        "system_version": "System Version",
        "playback_date": "Playback Date",
        "playback_period": "Playback Period",
        "retrieve_again": "Retrieve Again",
        "please_enter_password": "Please enter a password with at least 8 characters, including numbers, letters, and special characters [@#$%^&+=]",
        "passwords_do_not_match": "Passwords do not match",
        "enter_new_password2": "Enter new password",
        "current_password_too_simple": "Current password is too simple. To protect your account, please change it to a password with at least 8 characters, including numbers, letters, and special characters [@#$%^&+=]",
        "creation_time": "Creation Time",
        "login2": "Login",
        "welcome": "Welcome",
        "expired_login": "Authentication has expired, please log in again.",
        "control": "Control",
        "add_task": "Add Task",
        "program_list": "Program List",
        "terminal_info": "Terminal Info",
        "add_program": "Add Program",
        "material_management": "Material Management",
        "change_password": "Change Password",
        "enter_text_content": "Please enter text content",
        "hit_the_wall_on_back": "It's a wall behind",
        "last_ceremony": "Last Ceremony",
        "already_top_level": "Already at the top level",
        "already_last_one": "Already the last one",
        "white_fox": "White Fox",
        "control_img": "Image",
        "control_video": "Video",
        "control_streaming": "Streaming",
        "control_webPage": "Web",
        "control_subtitle": "Subtitle",
        "control_HDMI": "HDMI",
        "control_addbackground": "Background",
        "Up": "Upload",
        "onlyOne": "Only one control can be added",
        "clearBg": "Clear Background",
        "get_code": "Please enter the verification code first",
        "del_Null_Program": "Clear empty programs in the program group?",
        "please_select_date": "Please select at least one date",
        "last_size": "Remaining Space",
        "shutdown_tips": "Cannot be remotely turned on after shutdown",
        "last_size_upload": "Please reselect.",
        "end_date_earlier_than_start_date": "End date cannot be earlier than start date",
        "account_type": "Account Type",
        "user_type": "{level}-level User",
        "customer_type": "{level}-level Customer",
        "role_type": "Role",
        "super_administrator": "Super Administrator",
        "term_info_empty": "Terminal information is empty",
        "select_terminal_prompt": "Please click the list button in the upper right corner to select a terminal",
        "select": "Select",
        "data_empty": "Data is empty!",
        "content_review": "Content Review",
        "start_date": "Start Date",
        "end_date": "End Date",
        "start_time": "Start Time",
        "end_time": "End Time",
        "select_all": "All",
        "select_group": "Select Group",
        "review": "Review",
        "material_type": "Material Type",
        "audio": "Audio",
        "document": "Document",
        "material_status": "Material Status",
        "material_review": "Material Review",
        "current_selection_requires_review": "Does the current selection of materials require review?",
        "invCode": "Invitation Code",
        "tip_invitation_empty": "Please enter the invitation code",
        "enter_userName": "Please enter user account",
        enter_email:'Enter user email',
        file_less_38: 'File is less than 38kb',
        viewError: 'This file does not support preview',
        "user": "Personal Information",
        "phone_number_too_short": "The phone number must be longer than 9 digits",
        "oneImage": "The background image already exists. If you need to re-upload, please delete the existing one first.",
        del_title: 'Confirm Deletion',
        "del_message": "Are you sure you want to delete the control?",
        close:'Close',
        exit_group_name: 'Edit group name',
        group_management: 'Group Management',
        language:"Language",
        mixture: 'Mixed',
        date: 'Date',
        weeks: 'Weeks',
        time: 'Time',
        new_password: 'New Password',
        enter_invCode: 'Friendly Reminder: Please ask your superior administrator for the invitation code',
        msg_password: 'Friendly Reminder: Please enter a password with more than 8 characters, including numbers, letters, and special characters [@#$%^&+=]!',
        oneDoc: 'A document already exists. If you need to re-upload, please delete the existing one first',
        Sunday: 'Sunday',
        Monday: 'Monday',
        Tuesday: 'Tuesday',
        Wednesday: 'Wednesday',
        Thursday: 'Thursday',
        Friday: 'Friday',
        Saturday: 'Saturday',
        "input_error": "All form fields cannot be empty",
        video_tutorial:'Material Downloads',
        data_download:'Material',
        "view": "Watch",
        "selectDeviceOne": "This command can only select one device for query",
        "select_device_list": "Selected device list",
        "small_size": "Small",
        "medium_size": "Medium",
        "large_size": "Large",
        device_info:'Device Information',
        "notification": "Notification",
        "notif_title": "Notification content",
        "notif_msg": "Starting from November 5, 2024, the ETV Service Center will delete materials stored for over a year. Please be aware and back up important materials in advance. Thank you for your understanding and cooperation.",
        reduce: 'Reduce',
        bound_material: 'Bound Material',
        tip_material: 'The bound programs material cannot be deleted, please unbind the material first.',
        boundpo: 'Bound Program',
        bind_progron: 'This material is bound to a program and cannot be deleted.',
        index: 'Index',
        source: 'Source',
        getUploadSet_tip: 'Failed to get upload material disable.',
        getUploadstartTime_tip: 'Uploading materials is prohibited at the current time. Please upload during non-prohibited hours.',
        getUploadendTim: 'Material upload disabled',
        "download": "Download",
        "network_import": "Network Deployment",
        "mobile_mode": "Mobile Mode",
        "standalone_mode": "Standalone Mode",
        "connect_terminal": "Connect Terminal Device",
        "mobile_mode_tip": "(Keep the mobile phone and the device on the same local area network)",
        "scan_qr_wifi": "1. Connect the mobile phone to the device's hotspot, or connect to the same WIFI or the WIFI in the same local area network as the device.",
        "scan_qr_code": "2. Scan QR Code in the top left corner: Scan the terminal QR code to connect the device.",
        "device_List": "3. Device List in the top right corner: List all devices in the local area network, select the device.",
        "remote_Command": "Remote Command",
        "send_Command": "Send commands to the terminal device, the device will respond accordingly.",
        "quick_send_program": "Quick Send Program",
        "quick_send_steps": "Send quick display command → Get local images, videos, documents, select the material to be sent, click confirm → Set the program play time, click confirm → Program sent successfully.",
        "program_creation": "Program Creation",
        "new_program": "1. New Program: Edit a program name with at least two bytes (the program name will be automatically generated based on the creation time), select the screen orientation and display type according to the terminal device display screen, after successful creation, jump to the program editing interface.",
        "program_editing": "2. Program Editing: Select the program play mode (replace, insert, append), click '<img src='/static/images/help/icon.png' alt='' /> ' to add widgets (images, videos, mixed play, documents, etc.), freely adjust the size and position of the widgets, click '<img src='/static/images/help/icon_2.png' alt='' /> ' to add materials, set various attributes of the widgets below.",
        "program_sending": "Program Ending",
        "network_connection": "Network Connection",
        "network_methods": "There are two network connection methods:",
        "network_method_1": "(1) Settings → Network & Internet → WLAN → Connect to Network → Open ETV after connection → Network icon turns white, connection successful.",
        "network_method_2": "(2) Open ETV → Right-click → Software Settings → Select Network Distribution, click Next → Property Settings → WiFi Settings → Redirect to WiFi Connection Interface, connect to network → Return to previous interface → Exit back to ETV main interface → Network icon turns white, connection successful.",
        "send_program_steps": "Create the program → Click send → Device list pops up, select the device → Click confirm → Jump to the download progress interface, show the download progress → After 100% download, show complete → The device plays the sent program.",
        "account_registration": "Account Registration",
        "registration_methods": "There are two registration methods:",
        "registration_method_1": "(1) Contact superior to allocate account: Superior user logs in → Customer Management → Add Customer → Fill in customer information and click Confirm → Successfully created, customer list displays account information.",
        "registration_method_2": "(2) Free account registration: Backend server login interface → Register account → Fill in information as required and click Submit → Registration successful.",
        "invitation_code_source": "Invitation code source: Superior account logs in → System Configuration → Invitation Code Management → Add Invitation Code.",
        "device_connection": "Device Connection",
        "device_connection_steps": "Open ETV → Right-click → Software Settings → Select Network Distribution, click Next → Fill in server address (backend server address), control port (default 8899), username (superior allocated or self-registered account username) → Click Connect → After successful connection, device shows connected, backend device list displays device information.",
          "simple_mode_title": "Simple Mode (Default)",
          "simple_mode_description": "This mode is the default single-machine import method. Simply place the images and videos in the root directory of the USB drive and insert the USB drive into the motherboard to import successfully.",
          "simple_mode_note": "(PS: Only supports image and video import, equivalent to a mixed broadcast plugin. For other scenarios, use the second single-machine method.)",
          "regular_mode_title": "Regular Mode",
          "regular_mode_description": "Check 'Single-machine Mode' and click next to enter the single-machine mode interface (as shown below).",
          "regular_mode_steps": "1. Click 'Main Screen Layout' to enter the main screen layout settings.<br>2. Click 'Secondary Screen Layout' to enter the secondary screen layout settings.",
          "step_one": "Step 1:",
          "step_one_description": "Insert the USB drive, create a folder named 'etv-media' in the root directory of the USB drive, and create a 'main' folder under 'etv-media'. If you need to publish dual-screen tasks, create a 'double' folder under 'etv-media'.",
          "step_two": "Step 2:",
          "step_two_description": "According to the selected main or secondary screen layout, create folders 1/2/3/4 corresponding to the layout under 'main' or 'double'.",
          "step_three": "Step 3:",
          "step_three_description": "Copy the images/videos of the corresponding layout to the 1/2/3/4 folders under 'main/double'.",
          "step_four": "Step 4:",
          "step_four_description": "Supports full-screen PDF document playback, only one allowed.",
          "step_five": "Step 5:",
          "step_five_description": "Place the audio files in the MAIN/DOUBLE directory, the system will automatically switch and loop.",
          "play_order_title": "Playback Order:",
          "play_order_description": "1. Files named with numbers are played first, in ascending order of numbers.<br>2. Files named with letters are played next, in alphabetical order from A to Z.<br>3. Files named with Chinese characters are played last, in alphabetical order of the first letter of the first character.",
          "document_playback_note": "Regarding document playback (this switch is on by default): The document display switch is off by default for 3128 and M11 motherboards (to save performance overhead). You need to manually turn on the document display switch.",
            program_review: 'Program Review',
            pass: 'Pass',
            not_passed_or_not_reviewed: 'Not Passed or Not Reviewed',
            play_mode: 'Play Mode',
            review_status: 'Review Status',
            reject: 'Reject',
            review_content: 'Review Content',
            enter_review_content: 'Please enter review content',
        device_quantity: "Device Quantity",
        noMore: 'No more',
        "nameLengthLimit": "Please limit the name length to 50 characters.",
        "customer_title": "Account Query",
        "authorized_devices": "Authorized Devices",
        "enable": "Enable",
        "disable": "Disable",
        "expired": "Account Expired",
        "valid_date": "Valid Date",
        "valid_date_placeholder": "Enter valid date",
        "capacity_rule": "Server capacity must be a multiple of 100",
        "capacity_label": "Server Capacity (MB)",
        "download_speed": "Download Speed Limit",
        "submit_btn": "Submit",
        "sub_accounts":"Only supports modifying sub-accounts",
        plan_mode: 'Plan Mode',
        default_mode: 'Default Mode',
        "help": "Help",
        "network_mode": "Network Distribution",
        "phone_mode": "Phone Mode",
        "apk_download": "APK Download",
        "android": "Android",
        "ios": "iOS",
        "app_name": "ETV-H5 Information Publishing Assistant",
        "info_publish": "Information Publishing",
        "upload_material": "Upload Materials",
        "wx_config_incomplete": "WeChat configuration parameters are incomplete",
        "wx_missing_appid": "Missing appId in WeChat configuration",
        "wx_jssdk_not_loaded": "WeChat JS-SDK not loaded, please refresh the page and try again",
        "wx_version_not_support_scan": "Current WeChat version does not support scan function, please upgrade WeChat",
        "wx_signature_failed": "WeChat signature verification failed, please check backend signature algorithm and URL",
        "wx_domain_not_config": "Current domain not configured in WeChat Official Platform, please configure JS interface security domain",
        "wx_config_failed": "WeChat configuration failed",
        "wx_scan_init_failed": "Failed to initialize WeChat scan function",
        "browser_not_support_camera": "Your browser does not support camera function",
        "scan_content_unrecognized": "Scan content unrecognized, please try again!",
        "scan_lib_load_failed": "Failed to load scan library, please refresh the page and try again",
        "wx_scan_not_ready": "WeChat scan function not ready, initializing...",
        "wx_scan_permission_denied": "WeChat scan permission denied, please check WeChat settings or refresh the page",
        "scan_connect": "Scan to connect",
        "confirm_connect_device": "Confirm connection device",
        "confirm_connect_device_msg": "Connect to {deviceName}?",
        "data_lost_rescan": "Data lost, please scan again",
        "connect_failed_retry": "Connection failed, please retry",
        "qrcode_placeholder": "Please place the QR code within the frame",
        "camera_unauthorized": "Camera access not authorized",
        "camera_not_found": "Camera device not found",
        "camera_select_failed": "Unable to select camera device",
        "camera_start_failed": "Failed to start camera, please click to retry",
        "camera_permission_requesting": "Requesting camera permission",
        "camera_click_to_start": "Click screen to start camera",
        "camera_permission_denied": "Please allow camera access, click screen to retry",
        "camera_device_not_found": "Camera device not found",
        "camera_init_failed": "Camera initialization failed, click to retry",
        "scanner_not_initialized": "QR code scanner not initialized",
        "scan_start_failed": "Failed to start QR code scanning",
        "qrcode_format_error": "QR code data format is incorrect",
        "qrcode_verify_success": "QR code verification passed",
        "qrcode_verify_failed": "QR code verification failed",
        "process_failed": "Processing failed",
        "camera_not_found_current": "Unable to find current camera",
        "camera_switch_failed": "Unable to switch to another camera",
        "camera_no_alternatives": "No alternative cameras detected",
        "scan_QR_code": "Scan QR Code",
        'img_size': "Image pixel dimensions are abnormal, please check and re-upload.",
        "file_size_exceed_skip":'File size cannot exceed',
        "processing": "Processing",
        "failed": "Failed",
        "no_menu_permissions_contact_admin": "No menu permissions, please contact the administrator",
        "superior_name": "Superior Name",
    }

}
